import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from '@teamsnap/teamsnap-ui';
import './programs.scss';
import './members.scss';

import MemberList from '../../components/member/member-list';
import * as UserQuery from '../../core/gql/queries/show-user';
import { useMutation, useQuery } from '@apollo/client';
import { AuthService, Guards } from 'frontend-toolkit';
import { Icon, Grid, Cell } from '@teamsnap/teamsnap-ui';
import Stores from 'stores';

import * as QueryUserPreferences from '../../core/gql/queries/background-check-preferences';
import * as DismissYardstikAd from '../../core/gql/mutations/dismiss-yardstik-ad';

export interface Props extends RouteComponentProps<any> {}

const Members: React.FunctionComponent<Props> = (props) => {
  const {
    match: {
      params: { orgId },
    },
  } = props;

  const userQuery = useQuery(UserQuery.QUERY);
  const orgIdAsInt = parseInt(orgId);
  const [showBackgroundCheckInfo, setShowBackgroundCheckInfo] = React.useState(false);
  const [showYardstikAd, setShowYardstikAd] = React.useState(false);
  const queryUserPreferences = useQuery(QueryUserPreferences.QUERY, { fetchPolicy: 'network-only' } );
  const [dismissYardstikAd] = useMutation(DismissYardstikAd.MUTATION);

  React.useEffect(() => {
    const data = queryUserPreferences?.data
    Stores.organizationStore.selectOrganizationById(orgIdAsInt).then((orgData) => {
      if (orgData.country.toLowerCase() === 'united states') {
        Stores.backgroundCheckStore.loadAccounts(orgIdAsInt).then((bgData) => {
          if (bgData[0]?.partner?.toLowerCase() !== 'checkr') {
            setShowBackgroundCheckInfo(true)
            if (data?.userPartnerPreferences?.showYardstikAd) {
              setShowYardstikAd(data.userPartnerPreferences.showYardstikAd);
            }
          }
        });
      }
    });
  }, [queryUserPreferences.data, orgIdAsInt]);

  const dismissAd = async () => {
    setShowYardstikAd(false);
    try {
      await dismissYardstikAd();
    } catch {
      console.log('Error dismissing Yardstik ad');
    }
  };

  return (
    <div id="members" className="container hub-full-width">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1>Members</h1>
          </div>

          <div className="Grid-cell u-xs-size1of2 u-textRight button-list">
            { showBackgroundCheckInfo && (
              <Link to={`/organizations/${orgId}/members/background/new`}>
                <Button>Set Up Background Checks</Button>
              </Link>
            ) }
            { AuthService.checkGuard(Guards.AdminOrGhostInspector, userQuery.data?.user) && (
              <Link to={`/organizations/${orgId}/members/new`}>
                <Button color="primary" icon="plus">
                  New Member
                </Button>
              </Link>
            )}
          </div>
        </div>
        { showYardstikAd && (
          <div className="Feedback Feedback--dismissible" role="alert" style={{ paddingRight: '10px' }}>
            <Grid>
              <Cell mods="u-size11of12">
                <div className="Feedback-icon">
                  <Icon name="info" />
                </div>
                <strong>Check out our new background checks!</strong>
                <br />
                Sign up for background checks and speed up the staff hiring process through YardStik.{ ' ' }
                <Link to={`/organizations/${orgId}/members/background/new`}>
                  Learn more about Background Checks &rarr;
                </Link>
              </Cell>
              <Cell mods="u-size1of12 u-flexAlignSelfCenter" style={{ textAlign: 'right' }}>
                <button
                  type="button"
                  onClick={dismissAd}
                  style={{ backgroundColor: 'inherit', border: 'none', color: 'rgb(15, 82, 186', cursor: 'pointer' }}
                >
                  <Icon name="dismiss" mods="u-fontSizeLg" />
                </button>
              </Cell>
            </Grid>
          </div>
        ) }
        <div className="page-content-body u-padBottomXxl">
          <MemberList orgId={+orgId} />
        </div>
      </div>
    </div>
  );
};

export default Members;
